import React, { Component } from "react";
import Button from "../Button";
import * as ReactSpark from "react-spark";

export const COLLAPSED_CLASS = "chevron-down";
export const EXPANDED_CLASS = "chevron-up";
const { Icon } = ReactSpark;

class CollapseButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
      iconClass: EXPANDED_CLASS
    };
  }

  render() {
    const { loading, className, disabled, onClick, children } = this.props;
    const { iconClass } = this.state;
    return (
      <Button
        className={className}
        disabled={disabled}
        onClick={event => this.handleClick(event)}
        loading={loading}
      >
        {children} <Icon name={iconClass} />
      </Button>
    );
  }

  handleClick(event) {
    const { onClick } = this.props;
    const { collapsed } = this.state;

    onClick(event);

    this.setState({
      collapsed: !collapsed,
      iconClass: collapsed ? COLLAPSED_CLASS : EXPANDED_CLASS
    });
  }
}

export default CollapseButton;
